import { Kevel } from './kevel.js?v=2';
import { ViewItemListEvent } from './view-item-list-event.js';
import SponsorProductDrawer from './sponsored-product-drawer.js';

const newProductGridCard = {
  getCardSize: function () {
    const cardProduct = document.querySelector('#product-grid .card-product:not(.card-kevel)');
    if (cardProduct !== null) {
      return {
        width: cardProduct.getBoundingClientRect().width,
        height: cardProduct.getBoundingClientRect().height,
      };
    }
    return null;
  },
};

async function getProductById(handle) {
  return await fetch(`/products/${handle}.js`)
    .then((response) => response.json())
    .catch((err) => console.error(`Product handle "${handle}" not found!`));
}

function onSubmitHandler(evt, campaign) {
  evt.preventDefault();
  InterfaceX.addProductToCart();
  const form = evt.srcElement;
  let error = false;
  const cartNotification = document.querySelector('cart-notification');
  const cartDrawer = document.querySelector('cart-drawer');

  const qtyInput = form.querySelector('.quantity__input');
  let qty = 1;
  if (qtyInput && qtyInput.value) qty = qtyInput.value;

  const submitBtn = form.querySelector('.card-product__actions--btn');
  submitBtn.ariaDisabled = true;
  submitBtn.classList.add('loading');
  submitBtn.querySelector('.loading__spinner').classList.remove('hidden');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  let formData = new FormData(form);
  if (cartNotification || cartDrawer) {
    const cartNotificationSections = cartNotification.getSectionsToRender().map((section) => section.id);
    const cartDrawerSections = cartDrawer.getSectionsToRender().map((section) => section.id);

    formData.append('sections', [...cartNotificationSections, ...cartDrawerSections]);
    formData.append('sections_url', window.location.pathname);
    cartNotification.setActiveElement(document.activeElement);
  }

  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((data) => {
      if (data.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: data.errors || data.description,
          message: data.message,
        });

        submitBtn.ariaDisabled = true;
        submitBtn.querySelector('span').classList.add('hidden');
        error = true;
      } else if (!cartNotification && !cartDrawer) {
        window.location.href = routes.cart_url;
        return;
      }

      if (!error) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: data,
        });
        manageProductAddToCart(data.handle, qty, '');
      }

      cartNotification.renderContents(data);
    })
    .catch((error) => console.error(error))
    .finally(() => {
      submitBtn.classList.remove('loading');
      if (cartNotification && cartNotification.classList.contains('is-empty'))
        cartNotification.classList.remove('is-empty');
      if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
      if (!error) submitBtn.removeAttribute('aria-disabled');
      submitBtn.querySelector('.loading__spinner').classList.add('hidden');
    });

  fetch(`${campaign.clickUrl}&noredirect`);
}

const fdKevel = new Kevel();
fdKevel
  .setDivName('product-grid')
  .setParent('ProductGridContainer')
  .load(
    [
      {
        divName: 'brand-corner',
        networkId: 11757,
        siteId: 1303012,
        zoneIds: [329745],
        adTypes: [11421, 163],
        count: 1,
        adQuery: {
          ctavailability: {
            eq: 'in_stock',
            nullValuesMatch: true,
          },
        },
        eventIds: [40],
      },
      {
        divName: 'product-grid-3',
        networkId: 11757,
        siteId: 1303012,
        zoneIds: [329742],
        adTypes: [163],
        count: 1,
        adQuery: {
          ctavailability: {
            eq: 'in_stock',
            nullValuesMatch: true,
          },
        },
        eventIds: [40],
      },
      {
        divName: 'product-grid-7',
        networkId: 11757,
        siteId: 1303012,
        zoneIds: [335451],
        adTypes: [163],
        count: 1,
        adQuery: {
          ctavailability: {
            eq: 'in_stock',
            nullValuesMatch: true,
          },
        },
        eventIds: [40],
      },
      {
        divName: 'product-grid-9',
        networkId: 11757,
        siteId: 1303012,
        zoneIds: [333723],
        adTypes: [163],
        count: 1,
        adQuery: {
          ctavailability: {
            eq: 'in_stock',
            nullValuesMatch: true,
          },
        },
        eventIds: [40],
      },
      {
        divName: 'product-grid-11',
        networkId: 11757,
        siteId: 1303012,
        zoneIds: [335452],
        adTypes: [163],
        count: 1,
        adQuery: {
          ctavailability: {
            eq: 'in_stock',
            nullValuesMatch: true,
          },
        },
        eventIds: [40],
      },
      {
        divName: 'product-grid-15',
        networkId: 11757,
        siteId: 1303012,
        zoneIds: [333720],
        adTypes: [163],
        count: 1,
        adQuery: {
          ctavailability: {
            eq: 'in_stock',
            nullValuesMatch: true,
          },
        },
        eventIds: [40],
      },
      {
        divName: 'product-grid-17',
        networkId: 11757,
        siteId: 1303012,
        zoneIds: [333721],
        adTypes: [163],
        count: 1,
        adQuery: {
          ctavailability: {
            eq: 'in_stock',
            nullValuesMatch: true,
          },
        },
        eventIds: [40],
      },
      {
        divName: 'product-grid-19',
        networkId: 11757,
        siteId: 1303012,
        zoneIds: [335453],
        adTypes: [163],
        count: 1,
        adQuery: {
          ctavailability: {
            eq: 'in_stock',
            nullValuesMatch: true,
          },
        },
        eventIds: [40],
      },
      {
        divName: 'product-grid-21',
        networkId: 11757,
        siteId: 1303012,
        zoneIds: [335454],
        adTypes: [163],
        count: 1,
        adQuery: {
          ctavailability: {
            eq: 'in_stock',
            nullValuesMatch: true,
          },
        },
        eventIds: [40],
      },
      {
        divName: 'product-grid-28',
        networkId: 11757,
        siteId: 1303012,
        zoneIds: [335455],
        adTypes: [163],
        count: 1,
        adQuery: {
          ctavailability: {
            eq: 'in_stock',
            nullValuesMatch: true,
          },
        },
        eventIds: [40],
      },
      {
        divName: 'product-grid-30',
        networkId: 11757,
        siteId: 1303012,
        zoneIds: [333722],
        adTypes: [163],
        count: 1,
        adQuery: {
          ctavailability: {
            eq: 'in_stock',
            nullValuesMatch: true,
          },
        },
        eventIds: [40],
      },
    ],
    [`page=${window.location.pathname}`]
  )
  .onSuccess((ev) => {
    const data = ev.detail;

    if (data.decisions['brand-corner'] != null) {
      const campaign = data.decisions['brand-corner'][0];
      const campaignContent = data.decisions['brand-corner'][0].contents[0];
      const cardProductSize = newProductGridCard.getCardSize();
      const width = cardProductSize ? cardProductSize.width : campaignContent.data.width;
      const height = cardProductSize ? cardProductSize.height : campaignContent.data.height;
      const card = document.querySelector('#product-grid .card-kevel');

      if (card !== undefined && campaignContent.data.ctproduct_handle !== undefined) {
        createSponsoredProductCard(campaign, campaignContent, 0, card, width, height);
      } else {
        createBrandCornerCard(campaign, campaignContent, card, width, height);
      }

      fetch(campaign.impressionUrl);
    }

    document.querySelectorAll('#product-grid .card-kevel').forEach((card) => {
      const productCard = data.decisions[`product-grid-${card.parentNode.dataset.position}`];
      if (productCard == null || productCard === undefined) return;

      productCard.forEach((campaign) => {
        const campaignContent = campaign.contents[0];
        const cardProductSize = newProductGridCard.getCardSize();
        const width = cardProductSize ? cardProductSize.width : campaignContent.data.width;
        const height = cardProductSize ? cardProductSize.height : campaignContent.data.height;

        if (card !== undefined && campaignContent.data.ctproduct_handle !== undefined) {
          createSponsoredProductCard(campaign, campaignContent, card.parentNode.dataset.position, card, width, height);
          fetch(campaign.impressionUrl);
        }
      });
    });
  })
  .onComplete(() => {
    setTimeout(() => {
      const productGrid = document.getElementById('product-grid');
      if (!productGrid) return;

      productGrid.querySelectorAll('.card-kevel').forEach((item) => {
        if (!item.classList.contains('kevel-loaded')) {
          const parent = item.parentElement;
          if (!parent) return;
          parent.classList.add('kevel-slot-empty');
        }
      });

      fillEmptySponsoredSlots(productGrid).then(() => {
        rebuildGridWithSponsorPositions(productGrid);
      });
    }, 1000);
  })
  .onReload();

async function createSponsoredProductCard(campaign, campaignContent, index, card, width, height) {
  let viewItemListEvent = new ViewItemListEvent();
  const product = await getProductById(campaignContent.data.ctproduct_handle);

  card.dataset.jsonProduct = `{"id": ${product.id}, "handle": "${product.handle}", "media": [${product.media
    .map((media) => `{"${media.id}": {"src": "${media.src}", "width": ${media.width}, "height": ${media.height}}`)
    .join('}, ')}}], "title": "${product.title}", "variants": [${product.variants
    .map(
      (variant) =>
        `{"id": ${variant.id}, "title": "${variant.title}", "price": "${variant.price}", "compare_at_price": "${variant.compare_at_price}"}`
    )
    .join(', ')}], "vendor": "${product.vendor}", "type": "${product.type}", "tags": [${product.tags
    .map((tag) => `"${tag}"`)
    .join(', ')}], "featured_image": "${product.featured_image}", "created_at": "${product.created_at}"}`;
  card.dataset.bannerPromo = 'banner';
  card.dataset.bannerId = campaign.flightId || 'none';
  card.dataset.bannerName = campaignContent.data.ctcampaignName || 'none';
  card.dataset.creativeSlot = campaignContent.data.ctcreativeSlot || 'none';
  card.dataset.itemId = campaignContent.data.ctid || 'none';
  card.dataset.bannerIndex = index || campaign.flightId;
  card.dataset.bannerImg = product.featured_image;

  viewItemListEvent.setData(card.dataset.jsonProduct, campaign);
  const cardMediaWrapper = document.createElement('div');
  cardMediaWrapper.classList.add('card-product__image-wrapper');
  const cardMedia = document.createElement('div');
  cardMedia.classList.add('card-product__media');
  cardMediaWrapper.dataset.bannerPromo = 'banner';
  cardMediaWrapper.dataset.bannerId = campaign.flightId || 'none';
  cardMediaWrapper.dataset.bannerName = campaignContent.data.ctcampaignName || 'none';
  cardMediaWrapper.dataset.creativeSlot = campaignContent.data.ctcreativeSlot || 'none';
  cardMediaWrapper.dataset.itemId = campaignContent.data.ctid || 'none';
  cardMediaWrapper.dataset.bannerIndex = index || campaign.flightId;
  cardMediaWrapper.dataset.bannerImg = product.featured_image;

  if (product.media != null) {
    const link = document.createElement('a');
    link.href = product.url;
    link.addEventListener('click', function () {
      fetch(`${campaign.clickUrl}&noredirect`);
    });
    const principalImage = document.createElement('img');
    principalImage.classList.add('card-product__media--image', 'card-product__media--principal');
    principalImage.loading = 'lazy';
    principalImage.alt = product.media[0].alt;
    principalImage.src = product.media[0].src;
    principalImage.width = product.media[0].width;
    principalImage.height = product.media[0].height;
    link.appendChild(principalImage);

    if (product.media[1] != null) {
      const setSizes = [165, 360, 533, 720, 940, 1066];
      const srcSet = [];
      const secondImage = document.createElement('img');
      secondImage.classList.add('card-product__media--image', 'card-product__media--secondary');
      secondImage.loading = 'lazy';
      secondImage.src = `${product.media[1].src}&width=533`;
      secondImage.width = product.media[1].width;
      secondImage.height = product.media[1].height;
      secondImage.sizes =
        '(min-width: 1600px) 367px, (min-width: 1025px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)';
      secondImage.alt = product.media[1].alt;

      setSizes.forEach((size) => {
        if (product.media[1].width >= size) {
          srcSet.push(`${product.media[1].src}&width=${size} ${size}w`);
        }
      });
      secondImage.srcset = srcSet.join(', ');
      link.appendChild(secondImage);
    }

    cardMedia.appendChild(link);
  }

  // Tags
  const badges = document.createElement('div');
  badges.classList.add('card-product__badges', 'top', 'left');
  const promoBadges = document.createElement('div');
  promoBadges.classList.add('card-product__badges', 'bottom', 'right');
  promoBadges.style.paddingRight = '0';
  const promotedProductBadge = document.createElement('div');
  promotedProductBadge.classList.add('card-product__badges', 'bottom', 'left');

  if (product.compare_at_price > product.price) {
    const discountBadge = document.createElement('span');
    const calculatedDiscount = Math.round(
      ((product.compare_at_price - product.price) * 100) / product.compare_at_price
    );
    discountBadge.classList.add('card-product__badge', 'badge', 'color-scheme-b0e6e809-0af7-4286-8565-6812f1481b32');
    discountBadge.innerText = `${calculatedDiscount}%`;
    badges.appendChild(discountBadge);
  }

  if (product.tags.length > 0) {
    product.tags.forEach((tag) => {
      if (tag === 'Promo FD') {
        const promoFDBadge = document.createElement('span');
        promoFDBadge.classList.add('card-product__badge', 'badge', 'color-scheme-1d184c46-da8c-44db-9f62-0859f6f506c3');
        promoFDBadge.innerText = tag;
        badges.appendChild(promoFDBadge);
      }

      if (tag === 'Oportunidades') {
        const opportunityBadge = document.createElement('span');
        opportunityBadge.classList.add('badge-oportunity');
        opportunityBadge.innerHTML = `
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.8333 1H8.5552C7.88971 1 7.24163 1.28142 6.78329 1.76358L0.501414 8.29663C0.176916 8.63854 0 9.08495 0 9.5552C0 10.0438 0.189749 10.5085 0.53808 10.8504L4.81614 15.1285C5.15805 15.4768 5.6228 15.6666 6.11138 15.6666C6.37996 15.6666 6.63663 15.6116 6.87496 15.5016C6.82638 15.2697 6.83188 15.0313 6.89329 14.7985L7.18021 13.6554L6.53213 14.2788C6.30021 14.4988 5.90238 14.4923 5.67688 14.2668L1.39883 9.98878C1.28333 9.87328 1.22191 9.7202 1.22191 9.5552C1.22191 9.39662 1.28333 9.24995 1.38691 9.13995L7.66879 2.60691C7.9007 2.35666 8.21237 2.22191 8.5552 2.22191H12.8333C13.1697 2.22191 13.4447 2.49691 13.4447 2.83332V7.11138C13.4447 7.4533 13.3099 7.76496 13.0597 7.99779V8.00421L12.583 8.46254L12.8213 9.1042L13.628 9.15279L13.903 8.88421C14.3852 8.42496 14.6666 7.77688 14.6666 7.11138V2.83332C14.6666 1.825 13.8416 1 12.8333 1Z" fill="#1E1A49"/>
            <path d="M11.6118 5.27872C10.9381 5.27872 10.3899 4.73056 10.3899 4.05681C10.3899 3.38306 10.9371 2.83398 11.6118 2.83398C12.2855 2.83398 12.8337 3.38215 12.8337 4.05589C12.8337 4.72964 12.2855 5.27872 11.6118 5.27872Z" fill="#1E1A49"/>
            <path d="M12.609 15.5858L10.6949 14.2832L8.78077 15.5858C8.62309 15.6922 8.41683 15.6922 8.26007 15.5822C8.10423 15.4731 8.03181 15.2788 8.07856 15.0945L8.67443 12.7423L6.88316 11.2124C6.74107 11.0913 6.68698 10.8952 6.74657 10.7173C6.80615 10.5404 6.96841 10.4167 7.15542 10.4057L9.43806 10.2764L10.2649 8.02138C10.3309 7.84079 10.5033 7.7207 10.6949 7.7207C10.8865 7.7207 11.0588 7.84079 11.1248 8.02138L11.9517 10.2764L14.2343 10.4057C14.4213 10.4167 14.5827 10.5395 14.6432 10.7173C14.7028 10.8952 14.6487 11.0913 14.5066 11.2124L12.7153 12.7423L13.3112 15.0945C13.3579 15.2788 13.2855 15.4731 13.1297 15.5822C12.9748 15.6894 12.7685 15.694 12.609 15.5858Z" fill="#1E1A49"/>
          </svg>`;
        badges.appendChild(opportunityBadge);
      }

      if (tag === 'Dermocosmética') {
        const dermocosmeticBadge = document.createElement('span');
        dermocosmeticBadge.classList.add('badge-dermocosmetic');
        promoBadges.appendChild(dermocosmeticBadge);
      }

      if (tag === 'SkinAndCancer') {
        const skincancerBadge = document.createElement('span');
        skincancerBadge.classList.add('badge-skincancer');
        promoBadges.appendChild(skincancerBadge);
      }
    });
  }

  cardMedia.appendChild(badges);
  cardMedia.appendChild(promoBadges);
  cardMediaWrapper.appendChild(cardMedia);

  const cardContent = document.createElement('div');
  cardContent.classList.add('card-product__content');

  const promotedBadge = document.createElement('span');
  promotedBadge.classList.add('card-product__badge', 'badge', 'promoted');
  promotedBadge.style.backgroundColor = 'transparent';
  promotedBadge.style.fontSize = '10px';
  promotedBadge.style.cursor = 'pointer';
  promotedBadge.style.color = '#1E1A49';
  promotedBadge.style.padding = '0px';
  promotedBadge.style.lineHeight = '0px';
  const infoIcon = `
      <svg xmlns="http://www.w3.org/2000/svg" style="margin-left: .25em;" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-info-icon lucide-info"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
    `;
  promotedBadge.innerHTML = `Promoted ${infoIcon}`;
  promotedBadge.dataset.advertiserName = campaignContent.data.ctadvertiserName || 'Anonymous';
  promotedBadge.dataset.paidForBy = campaignContent.data.ctpaidForBy || 'Anonymous';
  promotedProductBadge.appendChild(promotedBadge);

  promotedBadge.addEventListener('click', function (e) {
    const isMobile = window.innerWidth < 768;
    const position = isMobile ? 'bottom' : 'right';
    const size = isMobile ? 'xs' : 'sm';

    const drawer = new SponsorProductDrawer(position, size);
    drawer.open(this.dataset.advertiserName, this.dataset.paidForBy, { position, size });
  });

  const cardProductName = document.createElement('h3');
  cardProductName.classList.add('card-product__name');
  const cardProductNameLink = document.createElement('a');
  cardProductNameLink.href = product.url;
  cardProductNameLink.classList.add('card-product__name--link');
  cardProductNameLink.innerText = product.title;
  cardProductNameLink.addEventListener('click', function () {
    fetch(`${campaign.clickUrl}&noredirect`);
  });
  cardProductName.appendChild(cardProductNameLink);
  cardContent.appendChild(promotedBadge);
  cardContent.appendChild(cardProductName);

  if (product.vendor) {
    const vendor = product.vendor.toLowerCase();
    const cardProductVendor = document.createElement('div');
    cardProductVendor.classList.add('card-product__info');
    const cardProductVendorLink = document.createElement('a');
    cardProductVendorLink.href = `/collections/${vendor}`;
    cardProductVendorLink.classList.add('card-product__vendor');
    cardProductVendorLink.innerText = String(vendor).charAt(0).toUpperCase() + String(vendor).slice(1);
    cardProductVendor.appendChild(cardProductVendorLink);
    cardContent.appendChild(cardProductVendor);
  }

  // Tags lentillas
  if (product.tags.length > 0) {
    product.tags.forEach((tag) => {
      if (tag === 'Progresivas' || tag === 'Progressivas' || tag === 'Astigmatismo') {
        const lentillasTag = document.createElement('div');
        lentillasTag.classList.add('card-product__lentillas-info', `lentillas-tag-${product.id}`);

        if (tag === 'Progresivas' || tag === 'Progressivas') {
          const progressiveTag = document.createElement('span');
          progressiveTag.style.color = '#df6d0a';
          progressiveTag.innerText = tag;
          lentillasTag.appendChild(progressiveTag);
        }

        if (tag === 'Astigmatismo') {
          const astigmatismTag = document.createElement('span');
          astigmatismTag.style.color = '#77bc1f';
          astigmatismTag.innerText = tag;
          lentillasTag.appendChild(astigmatismTag);
        }

        cardContent.appendChild(lentillasTag);
      }
    });
  }

  // Skeepers rating stars
  const skeepersRatingStarsContent = document.createElement('div');
  skeepersRatingStarsContent.classList.add('skeepers_product__stars');
  skeepersRatingStarsContent.dataset.productId = product.id;

  fetch(
    `https://api-product-reviews.cxr.skeepers.io/v1/websites/1de2b8a2-d5f2-a184-313d-d400a83af9be/products/ratings?ref=${product.id}`
  )
    .then((response) => response.json())
    .then((data) => {
      if (data.data[product.id] != null) {
        const skeepersRatingStars = document.createElement('div');
        skeepersRatingStars.classList.add('skeepers_product__stars');
        const reviewHeader = document.createElement('div');
        reviewHeader.classList.add('review__header');
        const stars = document.createElement('div');
        stars.classList.add('stars');

        const avgRating = data.data[product.id].average;
        const completedStars = parseInt(avgRating);
        const remainingStars = parseInt((avgRating - Math.floor(avgRating)) * 100);
        let star = '';
        Array(5)
          .keys()
          .forEach((index) => {
            const percentage = index + 1 <= completedStars ? 100 : remainingStars;
            star += `
          <span class="stars__item" style="background: linear-gradient(to right, rgba(233,199,21,1) 0%, rgba(233,199,21,1) ${percentage}%, rgba(233,199,21,0.3) ${percentage}%, rgba(233,199,21,0.3) 100%)">
            <svg class="star-svg" xmlns="http://www.w3.org/2000/svg" width="31.575" height="30.402" viewBox="0 0 31.575 30.402">
                <defs>
                  <linearGradient id="skeepers-86-linearGradient-100">
                    <stop offset="0%" stop-color="var(--skeepers-widget-star-color)"></stop>
                    <stop offset="100%" stop-color="var(--skeepers-widget-star-color)"></stop>
                  </linearGradient>
                </defs>

                <path data-name="Tracé 1" d="m977.223 685.241-7.775 7.8 2.031 10.988-9.836-5.168-9.678 5.211 1.7-11-8.012-7.767 10.885-1.628 4.726-10.011 5.031 9.99z" transform="translate(-945.648 -673.671)" fill="url(#skeepers-86-linearGradient-100)"></path>
            </svg>
          </span>
          `;
          });

        const starsRating = document.createElement('div');
        starsRating.classList.add('stars__rating');
        const rareTotal = document.createElement('span');
        rareTotal.classList.add('rate-total');
        rareTotal.innerText = data.data[product.id].nb_total;
        starsRating.appendChild(rareTotal);

        stars.innerHTML = star;
        reviewHeader.appendChild(stars);
        reviewHeader.appendChild(starsRating);
        skeepersRatingStars.appendChild(reviewHeader);
        skeepersRatingStarsContent.appendChild(skeepersRatingStars);
      }
    });

  cardContent.appendChild(skeepersRatingStarsContent);

  // Price
  const cardProductPrice = document.createElement('div');
  cardProductPrice.classList.add('price', 'card-product__price', 'price--on-sale');
  const cardProductPriceContainer = document.createElement('div');
  cardProductPriceContainer.classList.add('price__container');
  const cardProductPriceSale = document.createElement('div');
  cardProductPriceSale.classList.add('price__sale');
  const cardProductPriceItemSale = document.createElement('span');
  cardProductPriceItemSale.classList.add('price-item', 'price-item--sale');
  cardProductPriceItemSale.innerText = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(
    product.price / 100
  );
  cardProductPriceSale.appendChild(cardProductPriceItemSale);

  const cardProductPriceItemRegular = document.createElement('span');
  cardProductPriceItemRegular.classList.add('price-item', 'price-item--regular');
  cardProductPriceItemRegular.innerText = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(
    product.compare_at_price / 100
  );
  cardProductPriceSale.appendChild(cardProductPriceItemRegular);

  cardProductPriceContainer.appendChild(cardProductPriceSale);
  cardProductPrice.appendChild(cardProductPriceContainer);
  cardContent.appendChild(cardProductPrice);

  // Button action
  const cardProductActions = document.createElement('div');
  cardProductActions.classList.add('card-product__actions');

  const cardProductQuickAdd = document.createElement('div');
  cardProductQuickAdd.classList.add('quick-add', 'no-js-hidden');

  const productForm = document.createElement('div');
  const form = document.createElement('form');
  form.method = 'post';
  form.action = '/cart/add';
  form.id = 'product_form_id';
  form.acceptCharset = 'UTF-8';
  form.classList.add('form');
  form.enctype = 'multipart/form-data';
  form.noValidate = 'novalidate';
  form.dataset.type = 'add-to-cart-form';
  const inputFormType = document.createElement('input');
  inputFormType.type = 'hidden';
  inputFormType.name = 'form_type';
  inputFormType.value = 'product';
  const inputUtf = document.createElement('input');
  inputUtf.type = 'hidden';
  inputUtf.name = 'utf8';
  inputUtf.value = '✓';
  const inputVariantId = document.createElement('input');
  inputVariantId.type = 'hidden';
  inputVariantId.name = 'id';
  inputVariantId.value = product.variants[0].id;
  inputVariantId.classList.add('product-variant-id');
  const inputProductId = document.createElement('input');
  inputProductId.type = 'hidden';
  inputProductId.name = 'product-id';
  inputProductId.value = product.id;

  form.appendChild(inputFormType);
  form.appendChild(inputUtf);
  form.appendChild(inputVariantId);

  const buttonAddToCart = document.createElement('button');
  buttonAddToCart.type = 'submit';
  buttonAddToCart.name = 'add';
  buttonAddToCart.classList.add('card-product__actions--btn', 'quick-add__submit', 'button');
  buttonAddToCart.ariaHasPopup = 'dialog';
  buttonAddToCart.ariaLive = 'polite';

  const cartIcon = document.createElement('div');
  cartIcon.classList.add('icon-cart-css');
  cartIcon.style.display = 'block';
  cartIcon.style.padding = '12px';
  buttonAddToCart.appendChild(cartIcon);

  const addToCartText = document.createElement('span');
  addToCartText.innerText = 'Añadir';
  buttonAddToCart.appendChild(addToCartText);

  const spinnerStylesheet = document.createElement('link');
  spinnerStylesheet.rel = 'stylesheet';
  spinnerStylesheet.href = '/cdn/shop/t/20/assets/component-loading-spinner.css';
  spinnerStylesheet.type = 'text/css';
  spinnerStylesheet.media = 'all';
  buttonAddToCart.appendChild(spinnerStylesheet);

  const spinnerDiv = document.createElement('div');
  spinnerDiv.classList.add('loading__spinner', 'hidden');
  spinnerDiv.innerHTML = `
    <svg
      aria-hidden="true"
      focusable="false"
      class="spinner"
      viewBox="0 0 66 66"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
    </svg>
    `;
  buttonAddToCart.appendChild(spinnerDiv);

  form.appendChild(buttonAddToCart);
  form.appendChild(inputProductId);
  form.addEventListener('submit', (e) => onSubmitHandler(e, campaign));
  productForm.appendChild(form);
  cardProductQuickAdd.appendChild(productForm);
  cardProductActions.appendChild(cardProductQuickAdd);
  cardContent.appendChild(cardProductActions);

  card.textContent = '';
  card.appendChild(cardMediaWrapper);
  card.appendChild(cardContent);
  card.style.minWidth = `${width}px`;
  card.style.minHeight = `${height}px`;
  card.classList.add('kevel-image-banner');
  card.classList.add('kevel-loaded');
  card.classList.remove('animated');

  fdKevel.sendViewableImpression(card, campaign);
}

function fillEmptySponsoredSlots(grid) {
  if (!grid) return Promise.resolve();

  const emptySlots = Array.from(grid.querySelectorAll('.kevel-slot-empty')).filter(
    (slot) => slot.dataset.removing !== 'true'
  );

  if (emptySlots.length === 0) return Promise.resolve();

  const duration = 260;

  return new Promise((resolve) => {
    let pending = emptySlots.length;

    emptySlots.forEach((slot) => {
      slot.dataset.removing = 'true';
      const { height } = slot.getBoundingClientRect();
      slot.style.overflow = 'hidden';
      slot.style.maxHeight = `${height}px`;
      slot.style.opacity = '1';
      slot.style.transform = 'scale(1)';
      slot.style.transition = `max-height ${duration}ms ease, opacity ${duration}ms ease, transform ${duration}ms ease`;

      requestAnimationFrame(() => {
        slot.style.maxHeight = '0px';
        slot.style.opacity = '0';
        slot.style.paddingTop = '0px';
        slot.style.paddingBottom = '0px';
        slot.style.marginTop = '0px';
        slot.style.marginBottom = '0px';
        slot.style.transform = 'scale(0.97)';
      });

      setTimeout(() => {
        slot.remove();
        pending -= 1;
        if (pending === 0) resolve();
      }, duration + 60);
    });
  });
}

function rebuildGridWithSponsorPositions(grid) {
  if (!grid) return;

  const loadedItems = Array.from(grid.querySelectorAll('.card-kevel.kevel-loaded'))
    .map((card) => {
      const parent = card.parentElement;
      if (!parent) return null;
      const position = parseInt(parent.dataset.position, 10);
      if (!Number.isFinite(position)) return null;
      return { node: parent, position };
    })
    .filter(Boolean)
    .sort((a, b) => a.position - b.position);

  const sponsorMap = new Map();
  loadedItems.forEach(({ node, position }) => {
    sponsorMap.set(position, node);
  });

  const staticNodes = [];
  const productNodes = Array.from(grid.children)
    .filter((item) => {
      const parentPosition = parseInt(item.dataset.position, 10);
      if (sponsorMap.has(parentPosition)) return false;
      const sponsorCard = item.querySelector('.card-kevel');
      if (sponsorCard && sponsorCard.classList.contains('kevel-loaded')) return false;
      if (!item.dataset.originalIndex) {
        staticNodes.push(item);
        return false;
      }
      return true;
    })
    .sort((a, b) => {
      const indexA = parseInt(a.dataset.originalIndex, 10);
      const indexB = parseInt(b.dataset.originalIndex, 10);
      if (!Number.isFinite(indexA) && !Number.isFinite(indexB)) return 0;
      if (!Number.isFinite(indexA)) return 1;
      if (!Number.isFinite(indexB)) return -1;
      return indexA - indexB;
    });

  const maxSponsorPosition = sponsorMap.size > 0 ? Math.max(...sponsorMap.keys()) : 0;
  const totalSlots = Math.max(productNodes.length + loadedItems.length, maxSponsorPosition);
  const fragment = document.createDocumentFragment();

  staticNodes.forEach((node) => fragment.appendChild(node));

  const productQueue = [...productNodes];

  for (let slot = 1; slot <= totalSlots; slot += 1) {
    const sponsorNode = sponsorMap.get(slot);
    if (sponsorNode) {
      fragment.appendChild(sponsorNode);
      continue;
    }

    const productNode = productQueue.shift();
    if (!productNode) continue;
    fragment.appendChild(productNode);
  }

  productQueue.forEach((node) => fragment.appendChild(node));

  grid.innerHTML = '';
  grid.appendChild(fragment);
}

function createBrandCornerCard(campaign, campaignContent, card, width, height) {
  const cardMediaWrapper = document.createElement('div');
  cardMediaWrapper.classList.add('card-product__image-wrapper');
  cardMediaWrapper.style.padding = '0';
  cardMediaWrapper.style.height = '100%';
  const cardMedia = document.createElement('div');
  cardMedia.classList.add('card-product__media');
  cardMediaWrapper.dataset.bannerPromo = 'banner';
  cardMediaWrapper.dataset.bannerId = campaign.flightId || 'none';
  cardMediaWrapper.dataset.bannerName = campaignContent.data.ctcampaignName || 'none';
  cardMediaWrapper.dataset.creativeSlot = campaignContent.data.ctcreativeSlot || 'none';
  cardMediaWrapper.dataset.itemId = campaignContent.data.ctid || 'none';
  cardMediaWrapper.dataset.bannerIndex = 0 || campaign.flightId;
  cardMediaWrapper.dataset.bannerImg = `https://static.adzerk.net/Advertisers/${campaignContent.data.ctDesktopImage}`;

  const link = document.createElement('a');
  link.href = campaign.clickUrl;
  const principalImage = document.createElement('img');
  principalImage.style.objectFit = 'cover';
  principalImage.style.width = '100%';
  principalImage.style.height = '100%';
  principalImage.classList.add('card-product__media--principal');
  principalImage.loading = 'lazy';
  principalImage.alt = campaignContent.data.ctcreativeSlot;
  principalImage.src = `https://static.adzerk.net/Advertisers/${campaignContent.data.ctDesktopImage}`;
  principalImage.width = campaignContent.data.width;
  principalImage.height = campaignContent.data.height;
  link.appendChild(principalImage);

  card.textContent = '';
  cardMediaWrapper.appendChild(link);
  card.appendChild(cardMediaWrapper);
  card.style.minWidth = `${width}px`;
  card.style.minHeight = `${height}px`;
  card.classList.add('kevel-image-banner');
  card.classList.add('kevel-loaded');
  card.classList.remove('animated');

  fdKevel.sendViewableImpression(card, campaign);
}
